const weatherChoicesSrb = [
  {
    label: "Стабилно, благо време са зеленим пејзажима и земљаним браон тоновима.",

    value:
      'Steady, mild weather with green landscapes and earthy brown tones.{"Green":"3","Brown":"2"}',
  },
  {
    label: "Облачни дани са интроспективном сивом и мистериозним црним облацима.",
    value:
      'Cloudy days with introspective gray and mysterious black clouds.{"Gray":"3","Black":"2"}',
  },

  {
    label: "Мирни, ведри дани са плавим небом и магичним љубичастим вечерима.",
    value:
      'Calm, clear days with blue skies and magical violet evenings.{"Blue":"3","Violet":"2"}',
  },

  {
    label: "Врући, сунчани дани са наглим жутим и енергичним олујама.",
    value:
      'Hot, sunny days with bursts of yellow and energetic storms.{"Red":"3","Yellow":"2"}',
  },
];

export default weatherChoicesSrb;
